import OtpInput from "react-otp-input"

const OtpInputField = props => {
  const { index, otp, setOtp, customStyle, ...rest } = props

  const defaultStyle = {
    width: 46,
    height: 46,
    border: "1px solid #D6D6D6",
    borderRadius: 4,
  }
  const inputStyle = { ...defaultStyle, ...customStyle }

  return (
    <OtpInput
      value={otp}
      onChange={e => {
        setOtp(e)
      }}
      numInputs={index}
      isInputNum={true}
      containerStyle={{ gap: "12px", justifyContent: "center" }}
      inputStyle={inputStyle}
      focusStyle={{ outlineColor: "#009F2B" }}
      // separator={<span>-</span>}
      {...rest}
    />
  )
}
export default OtpInputField
